module.exports = __webpack_public_path__ + "static/media/icon-rule-error.15af443d.svg";